<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bath`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 2c4.605 0 8.518 2.965 9.934 7.09C35.938 9.913 41 16.274 41 24H15c0-7.17 4.36-13.165 10.188-14.648A6.497 6.497 0 0019.5 6h-1a6.5 6.5 0 00-6.5 6.5V45a1 1 0 01-1 1H9a1 1 0 01-1-1V12.5C8 6.701 12.701 2 18.5 2h1zM21 27a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zm9 1a1 1 0 00-1-1h-2a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6zm7-1a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zm-17.385-7c1.33-4.144 4.66-7 8.385-7 3.725 0 7.054 2.856 8.385 7h-16.77z"/></svg>
</template>
<script>

export default {
  name: 'IconBath',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
